import './Stores.scss';
import Component from './Stores.js';
export default Component;
